import { message } from "antd";
import { IConfirmModal } from "common/components";
import { register } from "register-service-worker";

const updatePopUp = () => {
  const confirmObject: any = {
    title: "Update Action",
    closeOnClickOutside: false,
    message:
      'If you press "Yes" button then you will get the Latest Changes , Or if you press "No" then you need to refresh the page manually for get latest Changes.',
    yesAlertFunc: () => {
      window.location.reload();
    },
    noAlertFunc: () => { },
    type: "confirm",
    buttonText: "Update"
  };
  IConfirmModal(confirmObject);
};

export const serviceWorkerPopUp = () => {
  // if new content add
  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  register(swUrl, {
    updated(registration: any) {
      console.log("New content is available; please refresh");
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      // updatePopUp();
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
      message.warning(
        "No internet connection found. App is running in offline mode.",
      );
    },
    error(error) {
      if (process.env.NODE_ENV === "production") {
        console.error("Error during service worker registration:", error);
      }
    },
  });
};